import { User } from 'types/common_types';
import { del, get, put, post } from './http-provider';

const SERVICE_URLS = {
  //Common Management
  uploadImage: 'Media/upload-form',

  // Auth
  login: 'auth/login',

  // Dashboard
  getDashboardStates: 'dashboard/auditstatus',

  // Users
  getUsers: 'user/list',
  getUserDetail: 'user/profile?userId=',
  createUser: 'user/create',
  updateUser: 'user/update',
  deleteUser: 'user/delete',
  changePassword: 'user/change-password',

  // Customers
  getCustomers: 'customer/list',
  createCustomer: 'customer/create',
  updateCustomer: 'customer/update',
  deleteCustomer: 'customer/delete',
  getCustomerDetail: 'customer/detail?id=',

  //Audits
  getAudits: 'audit/list',
  getAuditById: 'Reports/GetAuditDetailWithReports',
  createAudit: 'audit/create',
  deleteAudit: 'audit/delete?id=',
  editAudit: 'audit/update',

  //Forms Labels
  getLabels: "FieldNameMapping/nested",
  updateLabels: "FieldNameMapping/bulk-create",


};

// Common
const uploadImage = (data: any) => post(SERVICE_URLS.uploadImage, data, true);

// Auth
const login = (data: any) => post(SERVICE_URLS.login, data);

// Dashboard
const getDashboardStates = (params) => get(SERVICE_URLS.getDashboardStates, params);

// Users
const getUsers = (params: any) => get(SERVICE_URLS.getUsers, params);
const getUserDetail = (params: any) => get(SERVICE_URLS.getUserDetail + params);
const createUser = (data: any) => post(SERVICE_URLS.createUser, data);
const updateUser = (data: any) => put(SERVICE_URLS.updateUser, data);
const deleteUser = (data: any) => del(SERVICE_URLS.deleteUser, data);
const changePassword = (data: any) => post(SERVICE_URLS.changePassword, data);


// Customers
const getCustomers = (data: any) => get(SERVICE_URLS.getCustomers, data);
const createCustomer = (data: any) => post(SERVICE_URLS.createCustomer, data);
const updateCustomer = (data: any) => put(SERVICE_URLS.updateCustomer, data);
const deleteCustomer = (data: any) => del(SERVICE_URLS.deleteCustomer, data);
const getCustomerDetail = (params: any) => get(SERVICE_URLS.getCustomerDetail + params);

//Audits
const getAudits = (params: any) => get(SERVICE_URLS.getAudits, params);
const getAuditsById = (params: any) => get(SERVICE_URLS.getAuditById, params);
const createAudit = (data: any) => post(SERVICE_URLS.createAudit, data);
const deleteAudit = (params: any) => del(SERVICE_URLS.deleteAudit + params);
const editAudit = (data: any) => put(SERVICE_URLS.editAudit, data);

//Forms Labels
const getLabels = () => get(SERVICE_URLS.getLabels);
const updateLabels = (data: any) => post(SERVICE_URLS.updateLabels, data);

const apiServices = {
  // Common 
  uploadImage,

  // Auth
  login,

  // Dashboard
  getDashboardStates,

  // Users
  getUsers,
  getUserDetail,
  createUser,
  updateUser,
  deleteUser,
  changePassword,

  // Customers
  getCustomers,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  getCustomerDetail,

  // Audits
  getAudits,
  getAuditsById,
  createAudit,
  deleteAudit,
  editAudit,

  //Forms Labels
  getLabels,
  updateLabels
};

export default apiServices;
